(function () {
  'use strict';

  var BuyMoreSaveMore = window.customElements.get('buy-more-save-more')
    ? null
    : class extends HTMLElement {
        static get observedAttributes() {
          return ['quantity'];
        }

        constructor() {
          super();
          this._onCartChangedListener = this._onCartChanged.bind(this);
        }

        connectedCallback() {
          document.addEventListener('cart:change', this._onCartChangedListener);
          this._render();
        }

        disconnectedCallback() {
          document.removeEventListener('cart:change', this._onCartChangedListener);
        }

        attributeChangedCallback(name) {
          if (name === 'quantity') this._render();
        }

        get required() {
          return parseInt(this.getAttribute('required'), 10) || 1;
        }

        get quantity() {
          return parseInt(this.getAttribute('quantity'), 10) || 0;
        }

        set quantity(value) {
          this.setAttribute('quantity', value);
        }

        get productId() {
          return this.getAttribute('product-id');
        }

        get eligibleHandles() {
          return (this.getAttribute('data-eligible-handles') || '')
            .toLowerCase()
            .split(',')
            .map(function (h) { return h.trim(); })
            .filter(Boolean);
        }

        get eligibleIds() {
          return (this.getAttribute('data-eligible-ids') || '')
            .split(',')
            .map(function (s) { return s.trim(); })
            .filter(Boolean);
        }

        _lineIsEligible(line, knownIds) {
          if (knownIds && knownIds.length && knownIds.indexOf(String(line.product_id || '')) !== -1) {
            return true;
          }

          var handles = this.eligibleHandles;

          if (line.product_type) {
            var pt = line.product_type.toLowerCase().replace(/\s+/g, '-');
            if (handles.indexOf(pt) !== -1) return true;
          }

          if (Array.isArray(line.tags)) {
            for (var j = 0; j < line.tags.length; j++) {
              var t = (line.tags[j] || '').toLowerCase().replace(/\s+/g, '-');
              if (handles.indexOf(t) !== -1) return true;
            }
          }

          return false;
        }

        _onCartChanged() {
          this._refreshViaSectionRender();
        }

        /* PRIMARY: Section Rendering API - re-runs Liquid so collection
           membership is evaluated server-side (JS has no collection data). */
        _refreshViaSectionRender() {
          var sectionId = this.getAttribute('data-section-id');
          var self = this;

          if (!sectionId) {
            this._refreshViaCartJs();
            return;
          }

          var url = new URL(window.location.pathname + window.location.search, window.location.origin);
          url.searchParams.set('section_id', sectionId);

          fetch(url.toString(), { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = self.id ? doc.getElementById(self.id) : doc.querySelector('buy-more-save-more[product-id="' + self.productId + '"]');

              if (!fresh) {
                self._refreshViaCartJs();
                return;
              }

              self.setAttribute('data-eligible-ids', fresh.getAttribute('data-eligible-ids') || '');
              self.setAttribute('data-eligible-handles', fresh.getAttribute('data-eligible-handles') || '');
              self.quantity = parseInt(fresh.getAttribute('quantity'), 10) || 0;
            })
            .catch(function () { self._refreshViaCartJs(); });
        }

        /* FALLBACK: /cart.js + cached eligible product ids from Liquid. */
        _refreshViaCartJs() {
          var self = this;

          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (!cart || !Array.isArray(cart.items)) return;

              var knownIds = self.eligibleIds;

              var quantity = cart.items.reduce(function (sum, item) {
                return self._lineIsEligible(item, knownIds) ? sum + (item.quantity || 0) : sum;
              }, 0);

              self.quantity = quantity;
            })
            .catch(function () {});
        }

        _render() {
          var required = this.required;
          var quantity = Math.min(this.quantity, required);
          var remaining = Math.max(required - quantity, 0);
          var isComplete = remaining === 0;

          this.classList.toggle('is-complete', isComplete);

          Array.prototype.forEach.call(this.querySelectorAll('[data-bmsm-step]'), function (step) {
            var index = parseInt(step.getAttribute('data-index'), 10);
            step.classList.toggle('is-done', quantity >= index);
          });

          Array.prototype.forEach.call(this.querySelectorAll('[data-bmsm-connector]'), function (connector) {
            var index = parseInt(connector.getAttribute('data-index'), 10);
            connector.classList.toggle('is-done', quantity >= index);
          });

          var messageElement = this.querySelector('[data-bmsm-message]');

          if (messageElement) {
            var template = isComplete
              ? messageElement.getAttribute('data-reached')
              : messageElement.getAttribute('data-unreached');
            var replacement = '<span class="bmsm-remaining">' + remaining + '</span>';

            messageElement.innerHTML = (template || '').replace(/\[\s*remaining\s*\]/g, replacement);
          }
        }
      };

  if (BuyMoreSaveMore) {
    window.customElements.define('buy-more-save-more', BuyMoreSaveMore);
  }
})();